export default __webpack_public_path__ + "static/media/vertical.a3a02c52.svg";